// @ts-strict-ignore
import { useMemo, useState } from 'react';
import { FlatList, TouchableHighlight } from 'react-native';
import { View } from '@shared/components/View';
import { LinkedCard } from '@shared/components/blocks/lib/cards';
import { MBSearchBar } from '@shared/components/searchBar';
import { grid } from '@shared/styles';
import { RelatedCardsHeader } from '../RelatedCardsHeader';
import { MBCardQuantityHeader } from './header';
import { MBCardQuantityRow } from './row';

interface Props {
  cards: LinkedCard[];
  label: string;
  editable?: boolean;
  onRemove(card: LinkedCard): void;
  onChange(card: LinkedCard): void;
  onPressCard(card: LinkedCard): void;
  onEditCards(): void;
}

export function MBCardQuantityBottomSheetList({
  cards,
  editable,
  label,
  onRemove,
  onChange,
  onPressCard,
  onEditCards,
}: Props) {
  const [filter, setFilter] = useState('');
  const filteredCards = useMemo(
    () => cards.filter(card => card.name.toLowerCase().includes(filter.toLowerCase())),
    [cards, filter],
  );

  return (
    <>
      <View paddingHorizontal={1} paddingTop={2} paddingBottom={1}>
        <MBSearchBar value={filter} onChangeText={setFilter} />
      </View>
      <View paddingHorizontal={2}>
        <RelatedCardsHeader label={label} onEditCards={editable ? onEditCards : undefined} />
      </View>
      <MBCardQuantityHeader />
      <FlatList<LinkedCard>
        data={filteredCards}
        style={{ maxWidth: grid(40) }}
        keyExtractor={card => card.cardId}
        contentContainerStyle={{ paddingBottom: grid(1) }}
        renderItem={({ item: card }) => (
          // FlatList scrolling within the bottom sheet (modal) is problematic:
          // https://stackoverflow.com/questions/57537511/how-to-scroll-flatlist-in-modal-component
          <TouchableHighlight activeOpacity={1}>
            <MBCardQuantityRow
              card={card}
              editable={editable}
              onRemove={onRemove}
              onChange={onChange}
              onPressCard={onPressCard}
            />
          </TouchableHighlight>
        )}
      />
    </>
  );
}
